/*
 * PortalSphere password curtain: shared helpers.
 * Independent of the B2B tag gating.
 */
window.PSGate = (function () {
  function cookieName(key) {
    return 'ps_pwgate_' + key;
  }

  function isUnlocked(key) {
    return document.cookie.split('; ').indexOf(cookieName(key) + '=1') !== -1;
  }

  function unlock(key) {
    // No expiry, so this is a session cookie and clears when the browser closes.
    document.cookie = cookieName(key) + '=1; path=/; SameSite=Lax';
  }

  function digest(value) {
    var bytes = new TextEncoder().encode(value);
    return crypto.subtle.digest('SHA-256', bytes).then(function (buffer) {
      return Array.prototype.map
        .call(new Uint8Array(buffer), function (b) {
          return b.toString(16).padStart(2, '0');
        })
        .join('');
    });
  }

  function looksLikeEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  /*
   * Resolves to one of: 'ok', 'bad-email-format', 'bad-email', 'bad-password'.
   * allowedEmailHashes is an array. An empty array means any well formed
   * address is accepted and only the password is enforced.
   */
  function verify(email, password, passwordHash, allowedEmailHashes) {
    var address = (email || '').trim().toLowerCase();

    if (!looksLikeEmail(address)) {
      return Promise.resolve('bad-email-format');
    }

    return digest(address)
      .then(function (emailHash) {
        if (allowedEmailHashes.length && allowedEmailHashes.indexOf(emailHash) === -1) {
          return 'bad-email';
        }
        return digest(password || '').then(function (pwHash) {
          return pwHash === passwordHash ? 'ok' : 'bad-password';
        });
      })
      .catch(function () {
        return 'bad-password';
      });
  }

  function adoptAssets(doc) {
    var head = document.head;

    doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || head.querySelector('link[href="' + href + '"]')) return;
      head.appendChild(link.cloneNode(true));
    });

    doc.querySelectorAll('script[src]').forEach(function (script) {
      var src = script.getAttribute('src');
      if (!src || document.querySelector('script[src="' + src + '"]')) return;
      var tag = document.createElement('script');
      tag.src = src;
      tag.defer = true;
      head.appendChild(tag);
    });
  }

  return {
    isUnlocked: isUnlocked,
    unlock: unlock,
    digest: digest,
    verify: verify,
    adoptAssets: adoptAssets,
  };
})();
